<template>
 <div class="basicBackground selfLoveBackground">
   <ExerciseWithBottomControls>

     <transition
       name="custom-classes-transition"
       enter-active-class="animated fadeIn"
     >
         <div v-if="finished" class="padding text-center playerMessage">
           <img src="/img/love.png" class="icon" alt="">
           <div class="title2 light">I love you</div>
         </div>
     </transition>
     <transition
       name="custom-classes-transition"
       enter-active-class="animated fadeIn"
       leave-active-class="animated fadeOut"
     >
       <div v-if="justStarted" class="padding text-center playerMessage">
         <img src="/img/love.png" class="icon" alt="">
         <div class="title2 light">Self-Love Meditation</div>
       </div>
     </transition>
     <div class="padding">
       <Player src="/meditations/selflove/01.mp3" v-on:timeUpdate="onTimeUpdate"></Player>
     </div>

   </ExerciseWithBottomControls>
 </div>
</template>

<script>


  import ExerciseWithBottomControls from "@/components/containers/ExerciseWithBottomControls";
  import Player from "@/components/players/Player";
  export default {
    components: {
      Player,
      ExerciseWithBottomControls
    },
    data: () => ({
      finished: false,
      justStarted: true,
    }),

    computed: {

    },

    methods: {
      onTimeUpdate(data) {
        this.finished = data.finished;

        if (!this.finished && (data.currentTime/data.duration) <= 0.9) {
          this.justStarted = true;
        } else {
          this.justStarted = false;
        }
      },

    },

    async created() {

    }
  }



</script>

<style lang="scss">
  @import "../../assets/scss/index";

  .icon {
    width: 100px;
    height: 100px;
    margin-bottom: $bigMargin;
  }


</style>

